'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.sqrt;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/sqrt.js
// module id = 741
// module chunks = 0